// src/components/AdminSettings/tabs/RewardsTab.tsx
import React from 'react';
import { add, trash } from 'ionicons/icons';
import { Button } from '../../ui/Button';
import { Card } from '../../ui/Card';
import { Badge } from '../../ui/Badge';
import { List, type ListItemProps } from '../../ui/List';
import type { RewardsTabProps } from '../types';

export const RewardsTab: React.FC<RewardsTabProps> = ({
  rewards,
  onAddReward,
  onEditReward,
  onDeleteReward,
}) => {
  // Convert rewards to List items
  const rewardItems: ListItemProps[] = rewards.map(reward => ({
    id: reward.id,
    label: reward.name,
    start: { element: <span style={{ fontSize: 24 }}>{reward.icon}</span> },
    end: {
      element: (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Badge variant="primary" size="sm">⭐ {reward.points_cost}</Badge>
          <Button
            fill="clear"
            size="small"
            iconStart={trash}
            onClick={(e) => {
              e.stopPropagation();
              onDeleteReward(reward.id);
            }}
            aria-label="Delete reward"
            style={{ color: 'var(--ion-color-danger)' }}
          />
        </div>
      ),
    },
    onClick: () => onEditReward(reward),
  }));

  return (
    <>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 16,
      }}>
        <h3 style={{
          fontFamily: 'var(--kff-heading-font)',
          fontSize: 16,
          fontWeight: 600,
          margin: 0,
        }}>
          Available Rewards
        </h3>
        <Button variant="primary" size="small" iconStart={add} onClick={onAddReward}>
          Add Reward
        </Button>
      </div>

      {rewardItems.length > 0 ? (
        <List items={rewardItems} variant="default" size="md" lines="inset" />
      ) : (
        <Card style={{ textAlign: 'center' }}>
          <p style={{ color: 'var(--ion-color-medium)', marginBottom: 16 }}>
            No rewards defined yet
          </p>
          <Button variant="primary" onClick={onAddReward}>
            Add First Reward
          </Button>
        </Card>
      )}
    </>
  );
};

export default RewardsTab;
